import { ChatSmile, MedicalCase, OpenedBook, Suitcase, GovernmentBuilding } from 'components/icons'

export const CATEGORIES_OPTIONS = [
  {
    id: '1',
    Icon: Suitcase,
    color: 'red',
    label: 'Administrativo',
    value: 'ADMIN',
  },

  {
    id: '2',
    Icon: OpenedBook,
    color: 'blue',
    label: 'Educação',
    value: 'EDUCATION',
  },
  {
    id: '3',
    Icon: GovernmentBuilding,
    color: 'orange',
    label: 'Governamental',
    value: 'GOV',
  },
  {
    id: '4',
    Icon: MedicalCase,
    label: 'Saúde',
    value: 'HEALTH',
    color: 'green',
  },
  {
    id: '5',
    Icon: ChatSmile,
    color: 'purple',
    label: 'Social',
    value: 'SOCIAL',
  },
]
